export default "__VITE_ASSET__R37SICp4__"